import api from '@disco/api/server'
import { loadLibrary } from '@disco/state-management/actions/ExplorerActions'
import { addGroups } from '@disco/state-management/actions/GroupActions'
import { pushUINotification } from '@disco/utils/notifications'
import { useEffect } from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useParams, useNavigate } from 'react-router-dom'

const ChannelAcceptInvitePage = (): null => {
  const params = useParams<{ channelId: string }>()
  const channelId = params.channelId!
  const dispatch = useDispatch()
  const navigate = useNavigate()
  useEffect(() => {
    const join = async () => {
      pushUINotification({
        uid: `group-invite-accept-pending-${channelId}`,
        level: 'success',
        message: 'Joining channel...',
        dismissible: 'none',
        spinner: true,
      })

      try {
        const result = await api.joinChannel(parseInt(channelId))
        const rootChannel = dispatch(addGroups(result.groups))
        if (!rootChannel) throw new Error('Channel not found')
        pushUINotification({
          _replaceNotificationWithUID: `group-invite-accept-pending-${channelId}`,
          level: 'success',
          title: 'Channel joined!',
          message: `You have successfully joined the channel ‘${rootChannel.name}’.`,
          action: {
            label: 'Go to channel',
            callback: () => dispatch(loadLibrary(rootChannel)),
          },
          dismissible: 'button',
        })
      } catch (e) {
        console.error(e)
        pushUINotification({
          _replaceNotificationWithUID: `group-invite-accept-pending-${channelId}`,
          message:
            'This invite is no longer valid! Please ask the channel owner to send you a new invite.',
          level: 'error',
        })
      }

      return navigate('/')
    }

    join()
  }, [channelId, dispatch, navigate])
  return null
}

export default ChannelAcceptInvitePage
